import { render, staticRenderFns } from "./POLineItemsTab.vue?vue&type=template&id=5f3d25d3&scoped=true&"
import script from "./POLineItemsTab.vue?vue&type=script&lang=js&"
export * from "./POLineItemsTab.vue?vue&type=script&lang=js&"
import style0 from "./POLineItemsTab.vue?vue&type=style&index=0&id=5f3d25d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3d25d3",
  null
  
)

export default component.exports